
import { t } from 'i18next';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const BackToLogin = () => {
    const Navigate = useNavigate()
    const handleClick = () => {
        Navigate('/')
    }
    return (
    <p style={{ cursor: 'pointer' }} className="back-to-login d-flex align-items-center justify-content-center mt-4 pt-2" onClick={handleClick}>
       <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
        <path d="M16.3337 9.99935H4.66699M4.66699 9.99935L10.5003 15.8327M4.66699 9.99935L10.5003 4.16602" stroke="#475467" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        {t("backToLogIn")}
    </p>
);
};


export default BackToLogin;
